import { AffiliateLink } from "./types/affiliate_link";
import { emaki_brand } from "./types/emaki_brand";
import { Tag } from "./types/tag";

// tell ts this is gonna exist
declare let ko;

export default class TagDefaultsHelper {
  /**
   * Spread this into your buildViewModel return to get the properties required for these functions.
   */
  public static viewModelProperties = {
    tagDefaults: ko.observable({}),
    useTagDefaults: ko.observable({}),
    previewDefaultVignette: ko.observable(false),
  };

  /**
   * Html to enable a use default checkbox with the default value shown with it.
   * To hide the non-default value/override entry, wrap with <!-- ko if: useTagDefaults()['propertyname'] --> <!-- /ko -->
   * Must still define the onClickUseDefaultTagValue function in the view model where used.
   *
   * @param property
   * @returns
   */
  public static getUseTagDefaultHtml = (property: string): string => {
    return /* html */ `
            <div class="default-value">
                <div class="w-btn default-btn">
                    <button style="    margin: 0 .5rem 0 0;" class="btn only-icon icon i-circle"
                        type="button"
                        data-bind="
                            event: { click: onClickUseDefaultTagValue },
                            attr: { 'data-target': '${property}'},
                            css: { active: useTagDefaults()['${property}'] }
                        "
                    ><span class="hidden-text">default</span></button>
                </div>
            </div>
            <!-- ko if: tagDefaults()['${property}'] -->
                ${TagDefaultsHelper.getDefaultHtmlForProperty(property)}
            <!-- /ko -->
            <!-- ko ifnot: tagDefaults()['${property}'] -->
                    <span class="empty-label"
                        data-bind="
                            attr: { 'data-target': '${property}'},
                            css: { active: useTagDefaults()['${property}'] }
                        "
                    >[CURRENTLY EMPTY]</span>
            <!-- /ko -->
        `;
  };

  /**
   *
   * @param {string} property  string representing the property on the object being displayed
   * @returns
   */
  protected static getDefaultHtmlForProperty = (property: string): string => {
    if (property === "imageGroup") {
      return /*html*/ `
                <div class="default-value-content d-flex"
                    data-bind="
                        attr: { 'data-target': '${property}'},
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><strong><span data-bind="html: imageGroupSummary(tagDefaults().imageGroup)"></span></strong></div>
            `;
    } else if (property === "image") {
      return /*html*/ `
                <div class="default-value-content"
                    data-bind="
                        attr: { 'data-target': '${property}'},
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><img data-bind="attr: {src: (tagDefaults().image != null ? tagDefaults().image.url : '') }" style:"width: 10rem;"></div>
            `;
    } else if (property === "iconImage") {
      return /*html*/ `
                <div class="default-value-content d-flex"
                    data-bind="
                        attr: { 'data-target': '${property}'},
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><img data-bind="attr: {src: (tagDefaults().iconImage != null ? tagDefaults().iconImage.url : '') }" style:"width: 10rem;"></div>
            `;
    } else if (property === "bannerImage") {
      return /*html*/ `
                  <div class="default-value-content d-flex"
                      data-bind="
                          attr: { 'data-target': '${property}'},
                          css: { active: useTagDefaults()['${property}'] }
                      "
                  ><img data-bind="attr: {src: (tagDefaults().bannerImage != null ? tagDefaults().bannerImage.url : '') }" style:"width: 10rem;"></div>
              `;
    } else if (property === "tagColor") {
      return /*html*/ `
                <div class="default-value-content d-flex"
                    data-bind="
                        attr: { 'data-target': '${property}'},
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><strong><span data-bind="html: tagDefaults().tagColor || 'None'"></span></strong>
                <div data-bind="style: { 'background-color': tagDefaults().tagColor }"
                    style="
                        height: calc(3rem - 2px);
                        width: calc(3rem - 2px);
                        border: 1px solid #d1d1d1;
                        border-radius: 10%;
                        display: inline-block;
                        margin-left: 5px;
                    "
                ></div></div>
            `;
    } else if (property === "affiliateLinks") {
      return /*html*/ `
                <div class="default-value-content d-flex"
                    data-bind="
                        attr: { 'data-target': '${property}' },
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><strong><span data-bind="text: affiliateLinksSummary(tagDefaults().affiliateLinks)"></span></strong></div>
            `;
    } else if (property === "vignette") {
      return /*html*/ `
                <span data-bind="text: tagDefaults().vignette.name + ' (' + tagDefaults().vignette.id + ')'"
                    style="
                        display:block;
                        flex-basis:100%;
                        order:3;
                        padding: 0.5rem 0;
                    "
                ></span>
            `;
    } else {
      return /*html*/ `
                <div class="default-value-content d-flex"
                    data-bind="
                        attr: { 'data-target': '${property}'},
                        css: { active: useTagDefaults()['${property}'] }
                    "
                ><strong><span data-bind="html: tagDefaults()['${property}'] || 'None'"></span></strong></div>
            `;
    }
  };

  public static getBrandOwnerInfoText = (brandOwner: emaki_brand) =>
    brandOwner
      ? `This tag is owned by ${brandOwner.name} and its data will be shared with other brands on the network.`
      : "";

  public static imageGroupSummary = (imageGroup): string => {
    if (!imageGroup) {
      return "None";
    }

    let imageGroupJSON = JSON.parse(imageGroup);
    if (
      Array.isArray(imageGroupJSON) &&
      imageGroupJSON.length > 0 &&
      imageGroupJSON[0].images
    ) {
      let imageGroupCount = imageGroupJSON[0].images.length;
      if (imageGroupCount > 0) {
        return `${imageGroupCount} Images in Group`;
      }
    }

    return "None";
  };

  public static affiliateLinksSummary = (
    affiliateLinks: Array<object>,
    hasStreamRentBuyLinks: boolean
  ): string => {
    if (!affiliateLinks || affiliateLinks.length == 0) {
      return "None";
    }

    return hasStreamRentBuyLinks
      ? `${affiliateLinks.length} Affiliate Links on tag. Contains Advanced Option Links.`
      : `${affiliateLinks.length} Affiliate Links on tag.`;
  };

  /**
   * Used for toggling the use-default checkboxes meant for the tag's properties, not the specifications.
   *
   * @param data
   * @param event
   * @param vm  this.getTemplateViewModel() result from a template. Must have useTagDefaults property.
   * @returns
   */
  public static onClickUseDefaultTagValue = (
    data,
    event,
    vm: { useTagDefaults }
  ): boolean => {
    const propertyName = event.target.dataset.target;
    const checked = !vm.useTagDefaults()[propertyName];

    let otherProperty = {};
    if (propertyName == "image" || propertyName == "iconImage") {
      const otherPropertyName =
        propertyName === "image" ? "idImage" : "idIconImage";
      otherProperty[otherPropertyName] = checked;
    } else if (propertyName == "bannerImage") {
      const otherPropertyName = "idBannerImage";
      otherProperty[otherPropertyName] = checked;
    }

    vm.useTagDefaults({
      ...vm.useTagDefaults(),
      [propertyName]: checked,
      ...otherProperty,
    });

    return true;
  };

  public static getAffiliateLinks = (vm: {
    useTagDefaults;
    tagDefaults;
    isBrandOwner;
    affiliateLinks;
  }): Array<AffiliateLink> =>
    vm.useTagDefaults().affiliateLinks || vm.isBrandOwner()
      ? vm.tagDefaults().affiliateLinks
      : vm.affiliateLinks();

  public static setAffiliateLinks = (
    affiliateLinks: Array<AffiliateLink>,
    vm: {
      useTagDefaults;
      tagDefaults;
      isBrandOwner;
      affiliateLinks;
      updateTagDefaultValue;
    }
  ): void =>
    vm.useTagDefaults().affiliateLinks || vm.isBrandOwner()
      ? TagDefaultsHelper.updateTagDefaultValue(vm, "affiliateLinks", [
          ...affiliateLinks,
        ])
      : vm.affiliateLinks([...affiliateLinks]);

  public static updateTagDefaultValue(
    vm: { tagDefaults },
    key: string,
    value: any
  ): void {
    let tagDefaults = vm.tagDefaults();
    tagDefaults[key] = value;

    vm.tagDefaults(tagDefaults);
  }

  /**
   * Sets up the useTagDefaults property on the view model for the template.
   *
   * @param vm  this.getTemplateViewModel() result from a template. Must have the listed properties
   * @param imageWidgetForBrandTagImage  Widget being used for the tag image
   * @param imageWidgetForTagIconImage  Widget being used for the icon image
   * @param imageWidgetForTagBannerImage  Widget being used for the banner image
   * @param imageWidgetForBrandTagImageGroup  Widget being used for the image group
   * @param tag  Tag object. If supplied, we source the data from the tag.
   */
  public static setupUseTagDefaults = (
    vm: vmForUseTagDefaults,
    imageWidgetForBrandTagImage,
    imageWidgetForTagIconImage,
    imageWidgetForTagBannerImage,
    imageWidgetForBrandTagImageGroup,
    tag: Tag | null = null
  ): void => {
    if (vm.isBrandOwner() || (tag && !tag.details)) {
      vm.useTagDefaults({
        idImage: true,
        image: true,
        idIconImage: true,
        iconImage: true,
        idBannerImage: true,
        bannerImage: true,
        imageGroup: true,
        description: vm.isBrandOwner(),
        shortDescription: vm.isBrandOwner(),
        affiliateLinks: true,
        tagColor: true,
        idVignette: true,
        vignette: true,
      });
      return;
    }
    if (tag) {
      vm.useTagDefaults({
        idImage: tag.details.image === null,
        image: tag.details.image === null,
        idIconImage: tag.details.iconImage === null,
        iconImage: tag.details.iconImage === null,
        idBannerImage: tag.details.bannerImage === null,
        bannerImage: tag.details.bannerImage === null,
        imageGroup: tag.details.imageGroup === null,
        description: false,
        shortDescription: false,
        affiliateLinks: tag.details.affiliateLinks === null,
        tagColor: tag.details === null || tag.details.color === null,
        idVignette: tag.details === null || tag.details.vignette === null,
        vignette: tag.details === null || tag.details.vignette === null,
      });

      return;
    }
    const hasImage = imageWidgetForBrandTagImage.getImage() === null;
    const hasIcon = imageWidgetForTagIconImage.getImage() === null;
    const hasBanner = imageWidgetForTagBannerImage.getImage() === null;

    vm.useTagDefaults({
      idImage: hasImage,
      image: hasImage,
      idIconImage: hasIcon,
      iconImage: hasIcon,
      idBannerImage: hasBanner,
      bannerImage: hasBanner,
      imageGroup: imageWidgetForBrandTagImageGroup.getImage() === null,
      description: false,
      shortDescription: false,
      affiliateLinks: vm.affiliateLinks() === null,
      tagColor: vm.tagColor() === null,
      vignette: vm.idSelectedVignette(),
    });
  };

  // todo: if no preview, remove these two functions, and all references to them.
  public static onClickPreviewDefaultVignette = (vm: vmForUseTagDefaults) =>
    vm.previewDefaultVignette(true);

  public static onClickClosePreviewDefaultVignette = (
    vm: vmForUseTagDefaults
  ) => vm.previewDefaultVignette(false);
}

export type vmForUseTagDefaults =
  | TagsEditVmForUseTagDefaults
  | TagPickerVmForUseTagDefaults;

export type TagsEditVmForUseTagDefaults = {
  isBrandOwner: Function;
  useTagDefaults: Function;
  reviewText: Function;
  seoDescription: Function;
  affiliateLinks: Function;
  tagColor: Function;
  idSelectedVignette: Function;
  previewDefaultVignette: Function;
};

export type TagPickerVmForUseTagDefaults = {
  isBrandOwner: Function;
  useTagDefaults: Function;
  description: Function;
  seoDescription: Function;
  affiliateLinks: Function;
  tagColor: Function;
  idSelectedVignette: Function;
  previewDefaultVignette: Function;
};



// WEBPACK FOOTER //
// ./js/utils/TagDefaultsHelper.ts